import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_CONTRACT_TYPES } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const contractTypes = {
  namespaced: true,
  state: buildInitialState({
    contractTypeList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setContractTypes: (state, contractTypes) => {
      state.contractTypeList = contractTypes
    }
  },
  actions: {
    getContractTypes: ({ commit }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_CONTRACT_TYPES, parameters: filters })
        .then(json => json.data)
        .then(contractTypes => {
          commit('updateStatus', { status: COMPLETE })
          commit('setContractTypes', contractTypes)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default contractTypes
